import {
  GetInterfaceInvoicesResponseObj,
  GetInvoiceDetailsResponseObj,
  GetPaginatedInterfaceInvoicesParams,
  GetPaginatedInterfaceInvoicesResponse,
  InterfaceInvoice,
} from "@/types/interfaces/crm";
import axiosInstance from "../axiosInstance";

export async function getInvoiceDetails(invoiceId: string): Promise<GetInvoiceDetailsResponseObj> {
  const res = await axiosInstance.get(`/crm/admin/finance-qa/invoices/${invoiceId}`);
  const { data, references, meta }: GetInvoiceDetailsResponseObj = res.data;
  return {
    data,
    references,
    meta,
  } as GetInvoiceDetailsResponseObj;
}

interface AssignInvoicesPayload {
  assignee: string | null;
  assignedBy: string;
  invoices: {
    invoiceId: number;
    invoiceNumber: string;
    createdTime: string;
  }[];
}

export async function assignInvoices(payload: AssignInvoicesPayload): Promise<void> {
  await axiosInstance.post("/crm/admin/finance-qa/interface-invoices", payload);
}

export async function getInterfaceInvoices({
  assignees,
  clInvoiceIds,
}: {
  assignees?: string[];
  clInvoiceIds?: number[];
}): Promise<GetInterfaceInvoicesResponseObj> {
  const res = await axiosInstance.post("/crm/admin/finance-qa/interface-invoices/batchGet", {
    assignees,
    clInvoiceIds,
  });
  const { data, meta } = res.data;

  return {
    invoices: data || [],
    metaInfo: meta,
  };
}

export async function getPaginatedInterfaceInvoices(
  params: GetPaginatedInterfaceInvoicesParams,
): Promise<GetPaginatedInterfaceInvoicesResponse> {
  const res = await axiosInstance.get("/crm/admin/finance-qa/interface-invoices", {
    params: {
      page: params.page,
      limit: params.limit,
      sortBy: params.sortBy,
      sortOrder: params.sortOrder,
      searchText: params.searchText,
      dateFrom: params.dateFrom,
      dateTo: params.dateTo,
      status: params.status,
      assignee: params.assignee,
      postStatusBy: params.postStatusBy,
    },
  });

  return {
    data: res.data.data || [],
    meta: res.data.meta,
  };
}

export interface PostValidationEventPayload {
  clInvoiceId: number;
  clInvoiceNumber: string;
  agentNumber: string;
  clBranchNumber: string;
  totalPassed: number;
  totalFailed: number;
  failedValidations?: { validationId: string; message: string }[] | null;
}

export async function postValidationEvent(payload: PostValidationEventPayload): Promise<void> {
  await axiosInstance.post("/crm/admin/finance-qa/validation-events", payload);
}

// data is null when the record doesn't exist (travcom sends 200 with meta.isExpectedError).
export async function getOneInterfaceInvoice(invoiceId: string): Promise<{ data: InterfaceInvoice | null }> {
  const res = await axiosInstance.get(`/crm/admin/finance-qa/interface-invoices/${invoiceId}`);
  const { data }: { data: InterfaceInvoice | null } = res.data;
  return {
    data,
  };
}


export interface UpdateInterfaceInvoicePayload {
  clInvoiceNumber?: string;
  clCreatedTime?: string;
  status?: InterfaceInvoice["status"];
  notes?: string;
  assignee?: string | null;
  assignedBy?: string | null;
  postStatusBy?: string | null;
  postedAt?: string | null;
}

export async function updateInterfaceInvoice(
  clInvoiceId: number,
  payload: UpdateInterfaceInvoicePayload,
): Promise<{ data: InterfaceInvoice }> {
  const res = await axiosInstance.post(`/crm/admin/finance-qa/interface-invoices/${clInvoiceId}`, payload);
  return {
    data: res.data.data,
  };
}
